(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('MedFrequencyFrom', MedFrequencyFrom);

    MedFrequencyFrom.$inject = ['$resource'];

    function MedFrequencyFrom ($resource) {
        var resourceUrl =  'api/med-frequency-froms/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
